<template>
  <div>
    <div class="container">
      <el-breadcrumb class="hsb-breadcrumb" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>春节公告</el-breadcrumb-item>
      </el-breadcrumb>
      <img src="https://s1.huishoubao.com/static/PC_2020_year_main.png" alt="">
    </div>
  </div>
</template>

<script type="text/javascript">
import { Breadcrumb, BreadcrumbItem } from 'element-ui';

export default {
  tname: 'yearNotice',
  components: {
    [Breadcrumb.name]: Breadcrumb,
    [BreadcrumbItem.name]: BreadcrumbItem
  }
};
</script>

<style lang="postcss" scoped>

@import 'config.css';

.container {
  img {
    width: 1200px;
    height: 1395px;
  }
}
</style>



// WEBPACK FOOTER //
// src/projects/hsbpc/views/activies/yearNotice.vue